var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"fa-ul certifications-list",attrs:{"name":"certifications-list"}},[_c('label',{staticClass:"certifications-label d-none d-lg-block",attrs:{"for":"certifications-list"}},[_vm._v("Certifications")]),_c('ce-certification-badge',{attrs:{"certification":_vm.product.glovesCertifications.overall,"regionName":"Overall"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }